import {castArray, every, indexOf, isEmpty, isNull} from 'lodash-es';
import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';

export class RegExpPatternValidator {
  public static readonly regExpError = 'regExp';

  public static regExp(pattern: string | RegExp): ValidatorFn {
    if (!pattern) {
      return Validators.nullValidator;
    }
    let regex: RegExp;
    let regexStr: string;
    if (typeof pattern === 'string') {
      regexStr = '';

      if (pattern.charAt(0) !== '^') {
        regexStr += '^';
      }

      regexStr += pattern;

      if (pattern.charAt(pattern.length - 1) !== '$') {
        regexStr += '$';
      }

      regex = new RegExp(regexStr);
    } else {
      regexStr = pattern.toString();
      regex = pattern;
    }

    return (control: AbstractControl): ValidationErrors | null => {
      const {value} = control;

      if (RegExpPatternValidator.isEmptyInputValue(value)) {
        return null;
      }

      const controlValues = castArray(value);
      const regexTest = every(controlValues, el => regex.test(el));
      const rejectedValuesIdx: number[] = RegExpPatternValidator.getRejectedValuesIdx(controlValues, regex);

      return regexTest ? null :
        {[RegExpPatternValidator.regExpError]: {requiredPattern: regexStr, actualValue: value, rejectedIdx: rejectedValuesIdx}};
    };
  }

  private static isEmptyInputValue(value: any): boolean {
    return isNull(value) || isEmpty(value);
  }

  private static getRejectedValuesIdx(controlValues: string[], regex: RegExp): number[] {
    return controlValues.filter((el) => !regex.test(el))
      .map(item => indexOf(controlValues, item));
  }
}
